// src/pages/HomePage.jsx
import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';

import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import Services from '../components/Services';
import Listings from '../components/Listings';
import Testimonials from '../components/Testimonials';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import ServicesSection from '../components/ServicesSection';
import PrioritySectionMui from '../components/PrioritySectionMui';
import AboutSection from '../components/AboutSection';
import LatestNewsSection from '../components/LatestNewsSection';
import SellCTASection from '../components/SellCTASection';
import FeaturedPropertiesSection from '../components/FeaturedPropertiesSection';
import ServicesShortcuts from '../components/ServicesShortcuts';

export default function HomePage() {
  return (
    <>


      {/* Full-width hero carousel */}
      <HeroSlider/>
      <ServicesShortcuts/>
      <ServicesSection/>
      <FeaturedPropertiesSection/>
      <PrioritySectionMui/>
      <AboutSection/>
      <LatestNewsSection/>
      <SellCTASection/>


    </>
  );
}
